import axios from 'axios';
import { req } from './axiosFun';

// 定义通用api前缀
//系统设置接口url前缀(本地)
// var systemRoot = 'http://192.168.0.158/index.php';
//系统设置接口url前缀(线上)
var systemRoot = 'https://zlbb.qzhip.com/index.php';

/**
 * 系统设置API
 **/
 // 系统设置-短信记录
 export const systemMsgList = (params) => { return req("post", "/admin/system/getMessageList", params) };
 // 系统设置-短信记录-删除
 export const systemDelMsg = (params) => { return req("post", "/admin/system/delMessage", params) };
 // 系统设置-短信记录-批量删除勾选记录
 export const systemDelMsgCheck = (params) => { return req("post", "/admin/system/delMessageCheck", params) };
  // 系统设置-通知管理
  export const systemNoticeList = (params) => { return req("post", "/admin/system/getUserMsgList", params) };
  // 系统设置-通知管理-删除
  export const systemDelNotice = (params) => { return req("post", "/admin/system/delUserMsg", params) };
  // 系统设置-通知管理-批量删除勾选记录
  export const systemDelNoticeCheck = (params) => { return req("post", "/admin/system/delUserMsgCheck", params) };
   // 系统设置-通知管理-编辑通知
  export const systemEditNotice = (params) => { return req("post", "/admin/system/editUserMsg", params) };



export const systemUrl = 'https://zlbb.qzhip.com/index.php';
// export const systemUrl = 'https://zlbb.qzhip.com/index.php';


// WEBPACK FOOTER //
// ./src/api/systemMG.js